import axios, { AxiosResponse } from 'axios'
import {
  AtualizaFaturaDto,
  AtualizaValorAdicionalDto,
  FaturaView,
  PageResponseFaturaList,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const FINANCEIRO_URL = `${API_URL}/financeiro`
const FINANCEIRO_FATURA_URL = `${FINANCEIRO_URL}/fatura`

/**
 * Busca faturas
 * @param query string
 * @returns PageResponseFaturaList
 */
export const getFaturas = (query: string): Promise<PageResponseFaturaList> => {
  return axios
    .get(`${FINANCEIRO_FATURA_URL}?${query}`)
    .then((resp: AxiosResponse<PageResponseFaturaList>) => resp.data)
}

/**
 * Busca uma fatura
 * @param idFatura ID da Fatura
 * @returns FaturaView
 */
export const getFaturaById = (idFatura: number): Promise<FaturaView> => {
  return axios
    .get(`${FINANCEIRO_FATURA_URL}/${idFatura}`)
    .then((resp: AxiosResponse<FaturaView>) => resp.data)
}

/**
 * Deleta uma fatura
 * @param idFatura ID da Fatura
 * @returns FaturaView
 */
export const deleteFatura = (idFatura: number): Promise<FaturaView> => {
  return axios
    .delete(`${FINANCEIRO_FATURA_URL}/${idFatura}`)
    .then((resp: AxiosResponse<FaturaView>) => resp.data)
}

/**
 * Autoriza uma fatura
 * @param idFatura ID da Fatura
 * @param data AtualizaFaturaDto
 * @returns FaturaView
 */
export const autorizarFatura = (idFatura: number, data: AtualizaFaturaDto): Promise<FaturaView> => {
  return axios
    .patch(`${FINANCEIRO_FATURA_URL}/${idFatura}/autoriza`, data)
    .then((resp: AxiosResponse<FaturaView>) => resp.data)
}

/**
 * Cancela uma fatura
 * @param idFatura ID da Fatura
 * @param data AtualizaFaturaDto
 * @returns FaturaView
 */
export const cancelarFatura = (idFatura: number, data: AtualizaFaturaDto): Promise<FaturaView> => {
  return axios
    .patch(`${FINANCEIRO_FATURA_URL}/${idFatura}/cancela`, data)
    .then((resp: AxiosResponse<FaturaView>) => resp.data)
}

/**
 * Registra pagamento da fatura
 * @param idFatura ID da Fatura
 * @param data AtualizaFaturaDto
 * @returns FaturaView
 */
export const pagarFatura = (idFatura: number, data: AtualizaFaturaDto): Promise<FaturaView> => {
  return axios
    .patch(`${FINANCEIRO_FATURA_URL}/${idFatura}/paga`, data)
    .then((resp: AxiosResponse<FaturaView>) => resp.data)
}

/**
 * Atualiza valor adicional da fatura
 * @param idFatura ID da Fatura
 * @param data AtualizaValorAdicionalDto
 * @returns FaturaView
 */
export const atualizaValorFatura = (
  idFatura: number,
  data: AtualizaValorAdicionalDto
): Promise<FaturaView> => {
  return axios
    .patch(`${FINANCEIRO_FATURA_URL}/${idFatura}/adicional`, data)
    .then((resp: AxiosResponse<FaturaView>) => resp.data)
}
